import React, { useState } from 'react';
import api, { getCsrfToken } from '../api/axios';

export default function Profile() {
  const user = JSON.parse(localStorage.getItem('member_user') || 'null');

  const [profile, setProfile] = useState({
    name: user?.name || '',
    phone: user?.phone || '',
    email: user?.email || '',
  });

  const [profileError, setProfileError] = useState(null);
  const [profileSuccess, setProfileSuccess] = useState(null);
  const [savingProfile, setSavingProfile] = useState(false);

  const [password, setPassword] = useState({
    current_password: '',
    new_password: '',
    new_password_confirmation: '',
  });

  const [passwordError, setPasswordError] = useState(null);
  const [passwordSuccess, setPasswordSuccess] = useState(null);
  const [savingPassword, setSavingPassword] = useState(false);

  const handleProfileChange = e =>
    setProfile({ ...profile, [e.target.name]: e.target.value });

  const handlePasswordChange = e =>
    setPassword({ ...password, [e.target.name]: e.target.value });

  const handleProfileSubmit = async e => {
    e.preventDefault();
    setProfileError(null);
    setProfileSuccess(null);

    if (!/^628\d{7,13}$/.test(profile.phone)) {
      setProfileError('Nomor HP wajib diisi dengan format 628xxxx (contoh: 6281234567890).');
      return;
    }

    setSavingProfile(true);
    try {
      await getCsrfToken();
      const res = await api.put('/api/member/profile', {
        name: profile.name,
        phone: profile.phone,
        email: profile.email || null,
      });
      localStorage.setItem('member_user', JSON.stringify(res.data.user));
      setProfileSuccess(res.data.message || 'Profil berhasil diperbarui.');
    } catch (err) {
      const errors = err.response?.data?.errors;
      if (errors) {
        const firstError = Object.values(errors)[0];
        setProfileError(Array.isArray(firstError) ? firstError[0] : firstError);
      } else {
        setProfileError(err.response?.data?.message || 'Gagal memperbarui profil.');
      }
    } finally {
      setSavingProfile(false);
    }
  };

  const handlePasswordSubmit = async e => {
    e.preventDefault();
    setPasswordError(null);
    setPasswordSuccess(null);

    if (password.new_password !== password.new_password_confirmation) {
      setPasswordError('Konfirmasi password tidak cocok.');
      return;
    }

    setSavingPassword(true);
    try {
      await getCsrfToken();
      const res = await api.put('/api/member/password', {
        current_password: password.current_password,
        new_password: password.new_password,
        new_password_confirmation: password.new_password_confirmation,
      });
      setPasswordSuccess(res.data.message || 'Password berhasil diubah.');
      setPassword({ current_password: '', new_password: '', new_password_confirmation: '' });
    } catch (err) {
      const errors = err.response?.data?.errors;
      if (errors) {
        const firstError = Object.values(errors)[0];
        setPasswordError(Array.isArray(firstError) ? firstError[0] : firstError);
      } else {
        setPasswordError(err.response?.data?.message || 'Gagal mengubah password.');
      }
    } finally {
      setSavingPassword(false);
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card shadow mb-4">
            <div className="card-body p-4">
              <h5 className="card-title fw-bold mb-4">Pengaturan Profil</h5>
              {user?.id_peserta && (
                <p className="text-muted small mb-3">ID Peserta: {user.id_peserta}</p>
              )}

              {profileError && <div className="alert alert-danger">{profileError}</div>}
              {profileSuccess && <div className="alert alert-success">{profileSuccess}</div>}

              <form onSubmit={handleProfileSubmit}>
                <div className="mb-3">
                  <label className="form-label">Nama Lengkap</label>
                  <input
                    name="name"
                    className="form-control"
                    value={profile.name}
                    onChange={handleProfileChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Nomor HP</label>
                  <input
                    name="phone"
                    className="form-control"
                    value={profile.phone}
                    onChange={handleProfileChange}
                    placeholder="6281234567890"
                    required
                  />
                  <div className="form-text">Wajib diawali <strong>628</strong>.</div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Email <span className="text-muted">(opsional)</span></label>
                  <input
                    name="email"
                    type="email"
                    className="form-control"
                    value={profile.email}
                    onChange={handleProfileChange}
                    placeholder="email@contoh.com"
                  />
                </div>
                <button type="submit" className="btn btn-dark w-100" disabled={savingProfile}>
                  {savingProfile ? 'Menyimpan...' : 'Simpan Profil'}
                </button>
              </form>
            </div>
          </div>

          <div className="card shadow mb-4">
            <div className="card-body p-4">
              <h5 className="card-title fw-bold mb-4">Ganti Kata Sandi</h5>

              {passwordError && <div className="alert alert-danger">{passwordError}</div>}
              {passwordSuccess && <div className="alert alert-success">{passwordSuccess}</div>}

              <form onSubmit={handlePasswordSubmit}>
                <div className="mb-3">
                  <label className="form-label">Password Saat Ini</label>
                  <input
                    name="current_password"
                    type="password"
                    className="form-control"
                    value={password.current_password}
                    onChange={handlePasswordChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Password Baru</label>
                  <input
                    name="new_password"
                    type="password"
                    className="form-control"
                    value={password.new_password}
                    onChange={handlePasswordChange}
                    placeholder="Minimal 6 karakter"
                    required
                    minLength="6"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Konfirmasi Password Baru</label>
                  <input
                    name="new_password_confirmation"
                    type="password"
                    className="form-control"
                    value={password.new_password_confirmation}
                    onChange={handlePasswordChange}
                    required
                  />
                </div>
                <button type="submit" className="btn btn-dark w-100" disabled={savingPassword}>
                  {savingPassword ? 'Menyimpan...' : 'Ganti Password'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
